function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Draggable } from '@hello-pangea/dnd';
import { Button } from '@deephaven/components';
import { vsTrash, vsGripper } from '@deephaven/icons';
import { DbNameValidator } from '@deephaven/utils';
import InputEditor from "./InputEditor.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var INPUT_TYPE = Object.freeze({
  NAME: 'name',
  FORMULA: 'formula'
});
var EMPTY_FN = () => {
  // no-op
};
function CustomColumnInput(_ref) {
  var eventKey = _ref.eventKey,
    name = _ref.name,
    inputIndex = _ref.inputIndex,
    formula = _ref.formula,
    _onChange = _ref.onChange,
    onDeleteColumn = _ref.onDeleteColumn,
    onTabInEditor = _ref.onTabInEditor,
    invalid = _ref.invalid,
    isDuplicate = _ref.isDuplicate;
  var isValidName = name === '' || DbNameValidator.isValidColumnName(name);
  var handleFormulaEditorContentChanged = useCallback(formulaValue => {
    if (formulaValue !== undefined) {
      formulaValue.replace(/(\r\n|\n|\r)/gm, ''); // remove line break
      _onChange(eventKey, INPUT_TYPE.FORMULA, formulaValue);
    }
  }, [_onChange, eventKey]);
  return /*#__PURE__*/_jsx(Draggable, {
    draggableId: eventKey,
    index: inputIndex,
    disableInteractiveElementBlocking: true,
    children: (provided, snapshot) => /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      className: classNames('draggable-container', {
        dragging: snapshot.isDragging
      }),
      ref: provided.innerRef
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, provided.draggableProps), {}, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "custom-column-input-container",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "pb-3",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "d-flex flex-row custom-column-name",
            children: [/*#__PURE__*/_jsx("input", {
              className: classNames('form-control custom-column-input', {
                'is-invalid': invalid || !isValidName || isDuplicate
              }),
              placeholder: "Column Name",
              value: name,
              onChange: event => {
                _onChange(eventKey, INPUT_TYPE.NAME, event.target.value);
              }
            }), /*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: "ml-1 px-2",
              onClick: () => {
                onDeleteColumn(eventKey);
              },
              icon: vsTrash,
              tooltip: "Delete custom column"
            }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
              kind: "ghost",
              className: "btn-drag-handle",
              onClick: EMPTY_FN
              // eslint-disable-next-line react/jsx-props-no-spreading
            }, provided.dragHandleProps), {}, {
              icon: vsGripper,
              tooltip: "Drag column to re-order"
            }))]
          }), (!isValidName || isDuplicate) && /*#__PURE__*/_jsx("p", {
            className: "validate-label-error text-danger mb-0 mt-2 pl-1",
            children: !isValidName ? 'Invalid name' : 'Duplicate name'
          })]
        }), /*#__PURE__*/_jsx(InputEditor, {
          editorSettings: {
            language: 'deephavenDb'
          },
          editorIndex: inputIndex,
          placeholder: "Column Formula",
          value: formula,
          onContentChanged: handleFormulaEditorContentChanged,
          onTab: onTabInEditor,
          invalid: invalid
        })]
      }), /*#__PURE__*/_jsx("hr", {})]
    }))
  });
}
export default CustomColumnInput;
//# sourceMappingURL=CustomColumnInput.js.map